import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { shouldNotHide } from 'utils/valuesByKey';
import KTabs from '../KJRN/KTabs';
import KTab from '../KJRN/KTab';
import Certificate from './Certificate';
import Qualification from './Qualification';
import EmployeeMasterCourses from './EmployeeMasterCourses';
import Education from './Education';
import Career from './Career';
import ObjectsonLoan from './ObjectsonLoan';

const EmployeeBottonTabs = ({ valuesByKey }) => {
  const notHide = key => shouldNotHide(valuesByKey, key);

  return (
    <KTabs>
      {notHide('EmployeeMasterEducation') &&
        <KTab name={<FormattedMessage id="education.title" />}>
          <Education />
        </KTab>
      }
      {notHide('EmployeeMasterCertificate') &&
        <KTab name={<FormattedMessage id="certificate.title" />}>
          <Certificate />
        </KTab>
      }
      {notHide('EmployeeMasterCareer') &&
        <KTab name={<FormattedMessage id="career.title" />}>
          <Career />
        </KTab>
      }
      {notHide('EmployeeMasterQualification') &&
        <KTab name={<FormattedMessage id="qualification.title" />}>
          <Qualification />
        </KTab>
      }
      {notHide('EmployeeMasterCourse') &&
        <KTab name={<FormattedMessage id="course.title" />}>
          <EmployeeMasterCourses />
        </KTab>
      }
      {notHide('EmployeeMasterObjectOnLoan') &&
        <KTab name={<FormattedMessage id="loan.title" />}>
          <ObjectsonLoan />
        </KTab>
      }
    </KTabs>
  );
};

EmployeeBottonTabs.propTypes = {
  valuesByKey: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  valuesByKey: state.WebValuesReducer.valuesByKey,
});

export default connect(mapStateToProps)(EmployeeBottonTabs);



// WEBPACK FOOTER //
// ./src/components/profile/EmployeeBottonTabs.js